// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DatePicker__popover-defc2d {
  border-radius: 24px;
  border: 1px solid var(--base-20);
}

.DatePicker__calendar-e10812 {
  padding: 16px;
  min-height: auto;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/Form/Popup/DatePicker/DatePicker.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;AACF","sourcesContent":[".popover {\n  border-radius: 24px;\n  border: 1px solid var(--base-20);\n}\n\n.calendar {\n  padding: 16px;\n  min-height: auto;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": `DatePicker__popover-defc2d`,
	"calendar": `DatePicker__calendar-e10812`
};
module.exports = ___CSS_LOADER_EXPORT___;
